var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { responseHandler } from './apiHelper';
var jsonRequest = function (path, method, body) { return fetch(path, __assign({ method: method, credentials: 'same-origin', headers: {
        'Content-Type': 'application/json',
    } }, (body === undefined ? {} : { body: JSON.stringify(body) }))).then(responseHandler); };
/** Retrieves the authenticated user's profile from the Kotlin backend. */
export var fetchUserProfile = function () { return jsonRequest('/api/v1/users/me', 'GET'); };
/** Updates the authenticated user's profile. */
export var updateUserProfile = function (patch) { return jsonRequest('/api/v1/users/me', 'PATCH', patch); };
/** Deletes the authenticated user's account and revokes the browser session. */
export var deleteUserAccount = function () { return jsonRequest('/api/v1/users/me', 'DELETE'); };
/** Changes the password of the authenticated user. */
export var changePassword = function (request) { return jsonRequest('/api/v1/users/me/password', 'PUT', request); };
/**
 * Resets the password with a one-time code from the
 * "forgot password" email. The user does not need to be logged in.
 * */
export var resetPassword = function (request) { return jsonRequest('/api/v1/auth/reset-password', 'POST', request); };
